import {  IfObservable  } from './IfObservable';

export const _if = IfObservable.create;


// WEBPACK FOOTER //
// ../../src/observable/if.ts